import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Paper,
  IconButton,
  Typography,
  Popover,
  LinearProgress,
  Tooltip,
  useTheme,
} from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import ScreenShareIcon from '@mui/icons-material/ScreenShare';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';
import StopCircleIcon from '@mui/icons-material/StopCircle';
// import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CheckIcon from '@mui/icons-material/Check';
import WaveformVisualization from '../AudioControl/WaveformVisualization';

/**
 * PiPContent - Compact Picture-in-Picture player component
 * Displays meeting controls, timer, and audio visualization in a floating window
 */
const PiPContent = ({
  meetingTitle = 'Untitled Meeting',
  recordingTime = 0,
  isRecording = false,
  paused = false,
  isMicActive = false,
  isSystemActive = false,
  volume = 0,
  activeMicrophone = null,
  microphones = [],
  onMicClick,
  onSystemClick,
  onPauseClick,
  onResumeClick,
  onStopClick,
  onClose,
  onExpand,
  selectMicrophone,
  streamRef,
  transcriptContent = '',
}) => {
  const [micPopoverAnchor, setMicPopoverAnchor] = useState(null);
  const transcriptScrollRef = useRef(null);
  const prevScrollHeightRef = useRef(0);
  const prevScrollTopRef = useRef(0);
  const prevClientHeightRef = useRef(0);
  const theme = useTheme();

  // Auto-scroll when new chunks arrive only if user was near bottom before (use previous scroll state)
  useEffect(() => {
    if (!transcriptScrollRef.current) return;
    const container = transcriptScrollRef.current;
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;
    const prevScrollHeight = prevScrollHeightRef.current;
    const prevScrollTop = prevScrollTopRef.current;
    const prevClientHeight = prevClientHeightRef.current;

    const contentGrew = scrollHeight > prevScrollHeight;
    const wasNearBottom =
      prevScrollHeight === 0 ||
      prevScrollHeight - prevScrollTop - prevClientHeight < 100;

    if (contentGrew && wasNearBottom) {
      requestAnimationFrame(() => {
        container.scrollTop = container.scrollHeight;
        prevScrollHeightRef.current = container.scrollHeight;
        prevScrollTopRef.current = container.scrollTop;
        prevClientHeightRef.current = container.clientHeight;
      });
    }

    prevScrollHeightRef.current = scrollHeight;
    prevScrollTopRef.current = scrollTop;
    prevClientHeightRef.current = clientHeight;
  }, [transcriptContent]);

  const handleMicPopoverOpen = event => {
    setMicPopoverAnchor(event.currentTarget);
  };

  const handleMicPopoverClose = () => {
    setMicPopoverAnchor(null);
  };

  const openPopover = Boolean(micPopoverAnchor);
  const popoverId = openPopover ? 'pip-microphone-popover' : undefined;

  const formatTime = totalSeconds => {
    const seconds = Math.floor(totalSeconds);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');
    const paddedSecs = secs.toString().padStart(2, '0');
    return `${paddedHours}:${paddedMinutes}:${paddedSecs}`;
  };

  return (
    // old code here
    // <Box
    //   sx={{
    //     width: '100%',
    //     display: 'flex',
    //     flexDirection: 'column',
    //     backgroundColor: '#3c4043',
    //     fontFamily: 'inherit',
    //     color: '#ffffff',
    //   }}
    // >
    //   <Paper
    //     elevation={0}
    //     sx={{
    //       borderRadius: '8px',
    //       backgroundColor: '#3c4043',
    //       p: 1.5,
    //       display: 'flex',
    //       flexDirection: 'column',
    //       gap: 1,
    //       width: '100%',
    //       alignSelf: 'flex-start',
    //       color: '#ffffff',
    //     }}
    //   >
    //     {/* Top Row - Controls and Window Actions */}
    //     <Box
    //       sx={{
    //         display: 'flex',
    //         justifyContent: 'space-between',
    //         alignItems: 'center',
    //         gap: 0.5,
    //       }}
    //     >
    //       {/* Left side - Mic, Screen Share */}
    //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    //         <Tooltip title="Microphone" arrow>
            //   <Paper
            //     elevation={0}
            //     sx={{
            //       display: 'inline-flex',
            //       alignItems: 'center',
            //       borderRadius: '8px',
            //       bgcolor: isMicActive ? '#8ab4f8' : 'rgba(255, 255, 255, 0.1)',
            //       color: '#ffffff',
            //       p: 0,
            //     }}
            //   >
            //     <IconButton
            //       size="small"
            //       onClick={onMicClick}
            //       sx={{
            //         color: '#ffffff',
            //         p: 0.5,
            //         '&:hover': {
            //           bgcolor: 'rgba(255, 255, 255, 0.1)',
            //         },
            //       }}
            //     >
            //       <MicIcon sx={{ fontSize: '18px' }} />
            //     </IconButton>
            //     </Paper>
            // </Tooltip>

    //         <Tooltip title="System Audio" arrow>
              // <IconButton
              //   size="small"
              //   onClick={onSystemClick}
              //   sx={{
              //     bgcolor: isSystemActive
              //       ? '#8ab4f8'
              //       : 'rgba(255, 255, 255, 0.1)',
              //     color: '#ffffff',
              //     p: 0.75,
              //     '&:hover': {
              //       bgcolor: 'rgba(255, 255, 255, 0.15)',
              //     },
              //   }}
              // >
              //   <ScreenShareIcon sx={{ fontSize: '18px' }} />
              // </IconButton>
    //         </Tooltip>

            // {isRecording && !paused && (
            //   <Tooltip title="Pause" arrow>
            //     <IconButton
            //       size="small"
            //       onClick={onPauseClick}
            //       sx={{
            //         bgcolor: 'rgba(255, 255, 255, 0.1)',
            //         p: 0.75,
            //         color: '#ffffff',
            //         '&:hover': {
            //           bgcolor: 'rgba(255, 255, 255, 0.15)',
            //         },
            //       }}
            //     >
            //       <PauseCircleOutlineIcon sx={{ fontSize: '20px' }} />
            //     </IconButton>
            //   </Tooltip>
            // )}
            // {paused && (
            //   <Tooltip title="Resume" arrow>
            //     <IconButton
            //       size="small"
            //       onClick={onResumeClick}
            //       sx={{
            //         bgcolor: 'rgba(255, 255, 255, 0.1)',
            //         p: 0.75,
            //         color: '#ffffff',
            //         '&:hover': {
            //           bgcolor: 'rgba(255, 255, 255, 0.15)',
            //         },
            //       }}
            //     >
            //       <PauseCircleOutlineIcon sx={{ fontSize: '20px' }} />
            //     </IconButton>
            //   </Tooltip>
            // )}
            // <Tooltip title="Stop Recording" arrow>
            //   <IconButton
            //     size="small"
            //     onClick={onStopClick}
            //     sx={{
            //       bgcolor: 'rgba(255, 255, 255, 0.1)',
            //       p: 0.75,
            //       color: isRecording ? '#f44336' : 'rgba(255, 255, 255, 0.5)',
            //       '&:hover': {
            //         bgcolor: isRecording
            //           ? 'rgba(244, 67, 54, 0.2)'
            //           : 'rgba(255, 255, 255, 0.15)',
            //       },
            //     }}
            //     disabled={!isRecording}
            //   >
            //     <StopCircleIcon sx={{ fontSize: '20px' }} />
            //   </IconButton>
            // </Tooltip>
    //         <Typography
    //           variant="caption"
    //           sx={{
    //             color: '#ffffff',
    //             fontWeight: 600,
    //             fontSize: '12px',
    //             minWidth: '60px',
    //             textAlign: 'right',
    //           }}
    //         >
    //           {formatTime(recordingTime)}
    //         </Typography>
          //   {isRecording && !paused && streamRef?.current && (
          //     <Box
          //       sx={{
          //         width: '80px',
          //         height: '24px',
          //         display: 'flex',
          //         alignItems: 'center',
          //       }}
          //     >
          //       <WaveformVisualization
          //         isRecording={isRecording}
          //         micStream={streamRef.current}
          //       />
          //     </Box>
          //   )}
          // </Box>

    //       {/* Right side - Window Controls */}
    //       {/* <Box sx={{ display: 'flex', gap: 0.25 }}>
    //         {onClose && (
    //           <Tooltip title="Close" arrow>
    //             <IconButton
    //               size="small"
    //               onClick={onClose}
    //               sx={{
    //                 p: 0.5,
    //                 color: '#ffffff',
    //                 '&:hover': {
    //                   bgcolor: 'rgba(255, 255, 255, 0.1)',
    //                 },
    //               }}
    //             >
    //               <CloseIcon sx={{ fontSize: '16px' }} />
    //             </IconButton>
    //           </Tooltip>
    //         )}
    //       </Box> */}
    //     </Box>

    //     {/* Bottom Row - Pause, Stop, Waveform */}
    //     <Box
    //       sx={{
    //         display: 'flex',
    //         justifyContent: 'space-between',
    //         alignItems: 'center',
    //         gap: 1,
    //       }}
    //     >
    //       {/* Left side - Pause and Stop buttons */}
    //       <Box sx={{ display: 'flex', gap: 0.5 }}></Box>

    //       {/* Right side - Timer and Waveform */}
    //       <Box
    //         sx={{
    //           display: 'flex',
    //           alignItems: 'center',
    //           gap: 1,
    //           flex: 1,
    //           justifyContent: 'flex-end',
    //         }}
    //       ></Box>
    //     </Box>

    //     {/* Meeting Title */}
        // <Box
        //   sx={{
        //     pt: 0.5,
        //     borderTop: '1px solid rgba(255, 255, 255, 0.2)',
        //   }}
        // >
        //   <Typography
        //     variant="caption"
        //     sx={{
        //       color: 'rgba(255, 255, 255, 0.8)',
        //       fontSize: '11px',
        //       fontWeight: 500,
        //       display: 'block',
        //       overflow: 'hidden',
        //       textOverflow: 'ellipsis',
        //       whiteSpace: 'nowrap',
        //     }}
        //     title={meetingTitle}
        //   >
        //     {meetingTitle}
        //   </Typography>
        // </Box>
    //   </Paper>

    //   {/* Microphone Popover */}
    //   <Popover
    //     id={popoverId}
    //     open={openPopover}
    //     anchorEl={micPopoverAnchor}
    //     onClose={handleMicPopoverClose}
    //     anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    //     transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    //     slotProps={{
    //       paper: {
    //         sx: {
    //           backgroundColor: '#3c4043',
    //           color: '#e8eaed',
    //           borderRadius: '12px',
    //           p: 2,
    //           mt: 1,
    //           width: '280px',
    //         },
    //       },
    //     }}
    //   >
    //     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    //       {microphones.map(mic => (
    //         <Box
    //           key={mic.deviceId}
    //           onClick={() => {
    //             if (selectMicrophone) {
    //               selectMicrophone(mic.deviceId);
    //             }
    //             handleMicPopoverClose();
    //           }}
    //           sx={{
    //             display: 'flex',
    //             alignItems: 'center',
    //             gap: 2,
    //             cursor: 'pointer',
    //           }}
    //         >
    //           {activeMicrophone?.deviceId === mic.deviceId && (
    //             <CheckIcon sx={{ color: '#8ab4f8' }} />
    //           )}
    //           <Box>
    //             <Typography
    //               sx={{
    //                 color:
    //                   activeMicrophone?.deviceId === mic.deviceId
    //                     ? '#8ab4f8'
    //                     : '#e8eaed',
    //                 fontWeight: '500',
    //                 fontSize: '14px',
    //               }}
    //             >
    //               {mic.label || 'Unnamed Microphone'}
    //             </Typography>
    //             {activeMicrophone?.deviceId === mic.deviceId && (
    //               <Typography
    //                 variant="body2"
    //                 sx={{ color: '#bdc1c6', fontSize: '12px' }}
    //               >
    //                 System default
    //               </Typography>
    //             )}
    //           </Box>
    //         </Box>
    //       ))}

    //       {activeMicrophone && (
    //         <Box
    //           sx={{ display: 'flex', alignItems: 'center', gap: 2, pl: '2px' }}
    //         >
    //           <MicIcon sx={{ color: '#e8eaed', fontSize: '18px' }} />
    //           <LinearProgress
    //             variant="determinate"
    //             value={volume}
    //             sx={{
    //               flexGrow: 1,
    //               height: 4,
    //               borderRadius: 2,
    //               backgroundColor: '#5f6368',
    //               '& .MuiLinearProgress-bar': {
    //                 backgroundColor: '#8ab4f8',
    //               },
    //             }}
    //           />
    //         </Box>
    //       )}
    //     </Box>
    //   </Popover>
    // </Box>


    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#ffffff',
        fontFamily: 'inherit',
        color: '#3c4043',
        height: '100%',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: '8px',
          backgroundColor: '#ffffff',
          p: 1.5,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          minHeight: '215px',
          alignSelf: 'flex-start',
          color: '#3c4043',
        }}
      >
        <Box
          sx={{
            pt: 0.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: 'rgba(60, 64, 67, 0.8)',
              fontSize: '11px',
              fontWeight: 500,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: 1,
              minWidth: 0,
            }}
            title={meetingTitle}
          >
            {meetingTitle}
          </Typography>
          {onExpand && (
            <Tooltip title="Switch to Tab" arrow>
              <IconButton
                onClick={onExpand}
                size="small"
                sx={{
                  ml: 0.5,
                  p: 0.5,
                  color: 'rgba(60, 64, 67, 0.6)',
                  flexShrink: 0,
                  '&:hover': {
                    color: '#3c4043',
                    backgroundColor: 'rgba(60, 64, 67, 0.08)',
                  },
                }}
              >
                <OpenInNewIcon sx={{ fontSize: '14px' }} />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <Box
          ref={transcriptScrollRef}
          sx={{
            mt: 1,
            height: '100%',
            border: '1px solid #e9e9e9',
            borderRadius: '8px',
            marginBottom: '8px',
            padding: '8px',
            backgroundColor: '#FAFBFD',
            overflowY: 'auto',
            overflowX: 'hidden',
            '&::-webkit-scrollbar': {
              width: '6px',
            },  
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#c1c1c1',
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: '#a8a8a8',
              },
            },
          }}
        >
          <Typography
            variant="body2"
            component="div"
            sx={{
              color: 'rgba(60, 64, 67, 0.8)',
              fontSize: '12px',
              lineHeight: 1.5,
            }}
            dangerouslySetInnerHTML={{ __html: transcriptContent || '' }}
          />
        </Box>

        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: '0px',
          }}
        >

          {isRecording && !paused && streamRef?.current && (
            <Box
              sx={{
                width: '100%',
                height: '26px',
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-start',
                mb: '16px',
              }}
            >
              <WaveformVisualization
                isRecording={isRecording}
                micStream={streamRef.current}
              />
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: { xs: 0.5, sm: 0.75, md: 1 },
            marginBottom:'8px',
            height:  '56px',
            padding: '8px',
            borderRadius: { xs: '12px', sm: '14px', md: '16px' },
            background: '#FAFBFD',
           border: 'solid 1px #e9e9e9',
          }}
        >
          {/* Left Segmented Control */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              background: '#ffffff',
              padding: '3px',
              gap: '8px',
              // boxShadow: `
              //   0 1px 2px rgba(0, 0, 0, 0.05)
              // `,
            }}
          >
            <Tooltip title="Microphone" arrow>
              <IconButton
                onClick={onMicClick}
                sx={{
                  width: '30px',
                  height: '30px',
                  minWidth: '26px',
                  borderRadius: { xs: '6px', sm: '7px', md: '8px' },
                  padding: 0,
                  margin: 0,
                  background: 'transparent',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    background: 'transparent',
                  },
                }}
              >
                <MicIcon
                  sx={{
                    fontSize: '26px',
                    color: isMicActive
                      ? theme.palette.primary[500]
                      : theme.palette.text.disabled,
                  }}
                />
              </IconButton>
            </Tooltip>

            <Tooltip title="System Audio" arrow>
              <IconButton
                onClick={onSystemClick}
                sx={{
                  width: '26px',
                  height: '26px',
                  minWidth: '26px',
                  borderRadius: { xs: '6px', sm: '7px', md: '8px' },
                  padding: 0,
                  margin: 0,
                  background: 'transparent',
                  border: 'none',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    background: 'rgba(60, 64, 67, 0.05)',
                  },
                }}
              >
                <ScreenShareIcon
                  sx={{
                    fontSize: '26px',
                    color: isSystemActive
                      ? theme.palette.primary[500]
                      : theme.palette.text.disabled,
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>

          {/* Middle Timer Display */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: { xs: '8px', sm: '10px', md: '12px' },
              background: '#ffffff',
              padding: { xs: '8px 10px', sm: '10px 12px', md: '12px 16px' },
              // minWidth: { xs: '70px', sm: '80px', md: '90px' },
              minWidth: { xs: '85px', sm: '100px', md: '120px' },
              mx: { xs: 0.5, sm: 0.75, md: 1 },
              boxShadow: `
                0 1px 2px rgba(0, 0, 0, 0.05),
                inset 0 1px 2px rgba(0, 0, 0, 0.08)
              `,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: '#3c4043',
                fontWeight: 600,
                fontSize: { xs: '14px', sm: '14px', md: '14px' },
                letterSpacing: { xs: '0.2px', sm: '0.3px', md: '0.3px' },
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              {formatTime(recordingTime)}
            </Typography>
          </Box>

          {/* Right Play/Record Button */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 0.75, md: 1 } }}>
            {isRecording && !paused && (
              <Tooltip title="Pause" arrow>
                <IconButton
                  onClick={onPauseClick}
                  sx={{
                    width: { xs: '32px', sm: '36px', md: '40px' },
                    height: { xs: '32px', sm: '36px', md: '40px' },
                    borderRadius: '50%',
                    background: 'transparent',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      background: 'transparent',
                    },
                    '&:active': {
                      background: 'transparent',
                    },
                  }}
                >
                  <PauseCircleOutlineIcon
                    sx={{
                      fontSize: '30px',
                      color: '#3c4043',
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}
            {paused && (
              <Tooltip title="Resume" arrow>
                <IconButton
                  onClick={onResumeClick}
                  sx={{
                    width: { xs: '32px', sm: '36px', md: '40px' },
                    height: { xs: '32px', sm: '36px', md: '40px' },
                    borderRadius: '50%',
                    background: 'transparent',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      background: 'transparent',
                    },
                    '&:active': {
                      background: 'transparent',
                    },
                  }}
                >
                  <PlayCircleOutline
                    sx={{
                      fontSize: '30px',
                      color: '#3c4043',
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Stop Recording" arrow>
              <IconButton
                onClick={onStopClick}
                disabled={!isRecording}
                sx={{
                  width: { xs: '32px', sm: '36px', md: '40px' },
                  height: { xs: '32px', sm: '36px', md: '40px' },
                  borderRadius: '50%',
                  background: '#ffffff',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                  '&:hover': isRecording
                    ? {
                        background: '#f5f5f5',
                      }
                    : {},
                  '&:active': isRecording
                    ? {
                        background: '#eeeeee',
                      }
                    : {},
                  '&.Mui-disabled': {
                    opacity: 0.5,
                  },
                }}
              >
                <StopCircleIcon
                  sx={{
                    fontSize: '30px',
                    color: isRecording ? '#f44336' : 'rgba(60, 64, 67, 0.5)',
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      {/* Microphone Popover */}
      <Popover
        id={popoverId}
        open={openPopover}
        anchorEl={micPopoverAnchor}
        onClose={handleMicPopoverClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: '#ffffff',
              color: '#3c4043',
              borderRadius: '12px',
              p: 2,
              mt: 1,
              width: '280px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)',
            },
          },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {microphones.map(mic => (
            <Box
              key={mic.deviceId}
              onClick={() => {
                if (selectMicrophone) {
                  selectMicrophone(mic.deviceId);
                }
                handleMicPopoverClose();
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                cursor: 'pointer',
              }}
            >
              {activeMicrophone?.deviceId === mic.deviceId && (
                <CheckIcon sx={{ color: '#3c4043' }} />
              )}
              <Box>
                <Typography
                  sx={{
                    color:
                      activeMicrophone?.deviceId === mic.deviceId
                        ? '#3c4043'
                        : 'rgba(60, 64, 67, 0.8)',
                    fontWeight: '500',
                    fontSize: '14px',
                  }}
                >
                  {mic.label || 'Unnamed Microphone'}
                </Typography>
                {activeMicrophone?.deviceId === mic.deviceId && (
                  <Typography
                    variant="body2"
                    sx={{ color: 'rgba(60, 64, 67, 0.6)', fontSize: '12px' }}
                  >
                    System default
                  </Typography>
                )}
              </Box>
            </Box>
          ))}

          {activeMicrophone && (
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 2, pl: '2px' }}
            >
              <MicIcon sx={{ color: '#3c4043', fontSize: '18px' }} />
              <LinearProgress
                variant="determinate"
                value={volume}
                sx={{
                  flexGrow: 1,
                  height: 4,
                  borderRadius: 2,
                  backgroundColor: '#e0e0e0',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#3c4043',
                  },
                }}
              />
            </Box>
          )}
        </Box>
      </Popover>
    </Box>
  );
};

export default PiPContent;
